var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12","md":"12","sm":"12"}},[_c('carousel'),_c('news-grid',{attrs:{"max":4}}),_c('session-title',{staticClass:"pt-8 px-10 pb-5 ms-1",attrs:{"title":"fotos"}}),_c('gallery-cards',{attrs:{"max":4}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }